export default __webpack_public_path__ + "static/media/dk.ce7c702b.svg";